// import { PageService, ComponentService, pageComponentService } from '../Services/Axios/Api';
// class Page {
//     constructor() {
//         this.id = null;
//         this.title = '';
//         this.link = '';
//         this.isVisible = true;
//         this.components = [];
//         this.order = 0;
//         this.language = 'en'; // Default language
//         this.languageVersions = {}; // Store different language versions
//     }

//     async load(id, language = 'en') {
//         try {
//             this.id = id;
//             this.language = language;
            
//             // In a real implementation, you would pass language parameter to API
//             // const response = await PageService.GetPageByIdWithLanguage(id, language);
//             const response = await PageService.GetPageById(id);
            
//             if (response.isSuccess) {
//                 this.id = response.result?.id;
                
//                 // For now, we'll store the base data and manage language versions in memory
//                 // In a real implementation, the API would return language-specific data
//                 const baseData = {
//                     title: response.result?.title,
//                     link: response.result?.slug,
//                     isVisible: response.result?.isActive,
//                     components: response.result?.pageComponents ? response.result.pageComponents.map(pc => ({
//                         id: pc.id,
//                         componentId: pc.component?.id,
//                         name: pc.component?.componentId ? this.getComponentNameById(pc.component.componentId) : 'Unknown',
//                         data: pc.component?.data ? JSON.parse(pc.component.data) : {},
//                         order: pc.order,
//                         ComponentId: pc.component?.componentId
//                     })) : []
//                 };
                
//                 // Store base data for default language (usually 'en')
//                 this.languageVersions['en'] = baseData;
                
//                 // Set current language data
//                 const currentLangData = this.languageVersions[language] || baseData;
//                 this.title = currentLangData.title;
//                 this.link = currentLangData.link;
//                 this.isVisible = currentLangData.isVisible;
//                 this.components = currentLangData.components;
//             }
//         } catch (error) {       
//             console.error('Error loading page:', error);
//             throw error;
//         }
//     }

//     async loadWithLanguage(id, language) {
//         return this.load(id, language);
//     }

//     getComponentNameById(componentId) {
//         // This is a temporary solution - in a real app, you might want to cache this mapping
        
//         const componentMap = {
//             1: 'NavBasic',
//             2: 'Footer',
//             3: 'Layout',
//             4: 'DonationCard',
//             5: 'Slider',
//             6: 'MediaGallery',
//             7: 'SimpleNewsTicker',
//             8: 'SponsersGrid',
//             9: 'FloatingButton',
//             10: 'RichText',
//             11: 'ColSection',
//             12: 'HTML',
//         };
//         return componentMap[componentId] || 'Unknown';
//     }

//     async loadComponents() {
//         try {
//             const response = await PageService.GetComponentsByPageId(this.id);
//             if (response.isSuccess) {
//                 this.components = response.result.map(pc => ({
//                     id: pc.id,
//                     name: this.getComponentNameById(pc.component.componentId),
//                     data: pc.component.data ? JSON.parse(pc.component.data) : {},
//                     order: pc.order,
//                     ComponentId: pc.component.componentId
//                 }));
//             }
//         } catch (error) {
//             console.error('Error loading page components:', error);
//             throw error;
//         }
//     }

//     async save(language = null) {
//         try {
//             const currentLang = language || this.language;
            
//             // Store current data for the language being saved
//             this.languageVersions[currentLang] = {
//                 title: this.title,
//                 link: this.link,
//                 isVisible: this.isVisible,
//                 components: [...this.components]
//             };

//             const pageData = {
//                 title: this.title,
//                 isActive: this.isVisible,
//                 slug: this.link,
//                 description: `This is a description of the page ${this.title}`,
//                 language: currentLang, // Include language in save request
//                 languageVersions: this.languageVersions // Send all language versions
//             };

//             if (this.id) {
//                 // In a real implementation, you would call UpdatePageWithLanguage
//                 // const response = await PageService.UpdatePageWithLanguage(this.id, pageData, currentLang);
//                 const response = await PageService.UpdatePage(this.id, pageData);
//                 if (response && response.isSuccess) {
//                     return response.isSuccess;
//                 }
//             } else {
//                 const response = await PageService.CreatePage(pageData);
//                 if (response && response.isSuccess) {
//                     this.id = response.result.id;
//                     return response.result;
//                 }
//             }
//         } catch (error) {
//             console.error('Error saving page:', error);
//             throw error;
//         }
//     }

//     switchLanguage(language) {
//         // Save current language data
//         this.languageVersions[this.language] = {
//             title: this.title,
//             link: this.link,
//             isVisible: this.isVisible,
//             components: [...this.components]
//         };

//         // Switch to new language
//         this.language = language;
        
//         // Load data for new language or use base data
//         const langData = this.languageVersions[language] || this.languageVersions['en'] || {
//             title: '',
//             link: this.link, // Keep same slug
//             isVisible: this.isVisible,
//             components: []
//         };

//         this.title = langData.title;
//         this.link = langData.link;
//         this.isVisible = langData.isVisible;
//         this.components = langData.components;
//     }

//     getLanguageVersions() {
//         return this.languageVersions;
//     }

//     hasLanguageVersion(language) {
//         return this.languageVersions.hasOwnProperty(language);
//     }

//     getCurrentLanguage() {
//         return this.language;
//     }

//     async saveComponents() {
//         try {
//             if (!this.id) return;

//             // First, get current components to compare
//             const currentComponents = await ComponentService.GetComponentsByPageId(this.id);
//             const currentComponentIds = currentComponents.data.map(c => c.id);

//             // Update or add new components
//             for (const component of this.components) {
//                 const componentData = {
//                     pageId: this.id,
//                     componentType: component.type,
//                     componentData: component.data,
//                     order: component.order
//                 };

//                 if (component.id) {
//                     await ComponentService.UpdateComponent(component.id, componentData);
//                 } else {
//                     await ComponentService.CreateComponent(componentData);
//                 }
//             }

//             // Remove components that are no longer in the list
//             const newComponentIds = this.components.map(c => c.id).filter(id => id);
//             const componentsToRemove = currentComponentIds.filter(id => !newComponentIds.includes(id));
            
//             for (const componentId of componentsToRemove) {
//                 await ComponentService.DeleteComponent(componentId);
//             }
//         } catch (error) {
//             console.error('Error saving page components:', error);
//             throw error;
//         }
//     }

//     async addComponent(component) {
//         try {
//             if (!component || !component.name || !component.ComponentId) {
//                 throw new Error('Invalid component data');
//             }

//             const newComponent = {
//                 id: null,
//                 name: component.name,
//                 data: JSON.stringify(component.data || {}),
//                 order: this.components.length + 1
//             };

//             const componentId = await this.newComponent(component);
//             if (!componentId) {
//                 throw new Error('Failed to create component');
//             }

//             const assigned = await this.assignPageComponent(componentId, newComponent.order);
//             if (!assigned) {
//                 await ComponentService.DeleteComponent(componentId);
//                 throw new Error('Failed to assign component to page');
//             }
//             newComponent.id = componentId;
//             this.components.push(newComponent);
//             return newComponent;

//         } catch (error) {
//             console.error('Error in addComponent:', error);
//             throw error;
//         }
//     }

//     async newComponent(component) {
//         try {
//             const componentData = {
//                 id: 0,
//                 ComponentId: component.ComponentId,
//                 data: JSON.stringify(component.data || {}),
//                 tenantId: "tenant-1"
//             };

//             const response = await ComponentService.CreateComponent(componentData);
//             console.log('CreateComponent Response:', response);
            
//             if (!response || !response.id) {
//                 throw new Error('Component creation failed - no valid response');
//             }

//             return response.id;
//         } catch (error) {
//             console.error('Error in newComponent:', error);
//             throw error;
//         }
//     }

//     async assignPageComponent(id, order) {
//         try {
//             if (!this.id || !id) {
//                 throw new Error('Invalid page or component ID');
//             }

//             const pageComponentData = {
//                 pageId: this.id,
//                 componentId: id,
//                 order: order
//             };
//             const response = await pageComponentService.CreatePageComponent(pageComponentData);
//             console.log('CreatePageComponent Response:', response);
//             if (!response) {
//                 throw new Error('Failed to assign component to page - no response');
//             }
//             return true;
//         } catch (error) {
//             console.error('Error in assignPageComponent:', error);
//             throw error;
//         }
//     }

//     updateComponent(componentId, updatedData) {
//         const index = this.components.findIndex(c => c.id === componentId);
//         if (index !== -1) {
//             this.components[index] = {
//                 ...this.components[index],
//                 ...updatedData
//             };
//         }
//     }

//     async removeComponent(componentId) {
//         try {
//             await pageComponentService.DeletePageComponent(componentId);
//             this.components = this.components.filter(c => c.id !== componentId);
//             // Reorder remaining components
//             this.components.forEach((component, index) => {
//                 component.order = index + 1;
//             });
//         } catch (error) {
//             console.error('Error removing component:', error);
//             throw error;
//         }
//     }


//     reorderComponents(newOrder) {
//         this.components = newOrder.map((componentId, index) => {
//             const component = this.components.find(c => c.id === componentId);
//             if (component) {
//                 return { ...component, order: index + 1 };
//             }
//             return null;
//         }).filter(Boolean);
//     }

//     getComponents() {
//         return [...this.components];
//     }

//     setComponents(components) {
//         this.components = components;
//     }

//     getTitle() {
//         return this.title;
//     }

//     setTitle(title) {
//         this.title = title;
//     }

//     getLink() {
//         return this.link;
//     }

//     setLink(link) {
//         this.link = link;
//     }

//     isPageVisible() {
//         return this.isVisible;
//     }

//     setVisibility(isVisible) {
//         this.isVisible = isVisible;
//     }

//     getOrder() {
//         return this.order;
//     }

//     setOrder(order) {
//         this.order = order;
//     }

//     async delete() {
//         try {
//             if (this.id) {
//                 await PageService.DeletePage(this.id);
//             }
//         } catch (error) {
//             console.error('Error deleting page:', error);
//             throw error;
//         }
//     }

//     async saveComponentOrder() {
//         try {
//             if (!this.id) return;

//             const orderData = this.components.map((component, index) => ({
//                 id: component.id,
//                 order: index + 1
//             }));

//             const response = await pageComponentService.UpdatePageComponentOrder(orderData);
//             if (!response || !response.isSuccess) {
//                 throw new Error('Failed to save component order');
//             }
//             return response;
//         } catch (error) {
//             console.error('Error saving component order:', error);
//             throw error;
//         }
//     }
// }

// export const createPageInstance = () => {
//     return new Page();
// };
import { PageService, ComponentService, pageComponentService } from '../Services/Axios/Api';
class Page {
    constructor() {
        this.id = null;
        this.title = '';
        this.link = '';
        this.isVisible = true;
        this.isTitleVisible = true;
        this.components = [];
        this.order = 0;
        this.language = 'en';
    }

    async load(slug , language) {
        try {
            // this.id = id;
            const response = await PageService.GetPageBySlugAndLanguage(slug , language);
            if (response.isSuccess) {
                this.id = response.result?.id;
                this.title = response.result?.title;
                this.link = response.result?.slug;
                this.isVisible = response.result?.isActive;
                this.isTitleVisible = response.result?.isTitleVisible ?? true;
                this.language = response.result?.language;
                console.log('response.result', response.result);
                // Map pageComponents to our components array
                if (response.result?.pageComponents) {
                    console.log('response.result.pageComponents', response.result.pageComponents);
                    this.components = response.result.pageComponents.map(pc => ({
                        
                        id: pc.id,
                        componentId: pc.component?.id,
                        name: pc.component?.componentId ? this.getComponentNameById(pc.component.componentId) : 'Unknown',
                        data: pc.component?.data ? JSON.parse(pc.component.data) : {},
                        order: pc.order,
                        ComponentId: pc.component?.componentId
                    }));
                }
            }
        } catch (error) {       
            console.error('Error loading page:', error);
            throw error;
        }
    }

    getComponentNameById(componentId) {
        // This is a temporary solution - in a real app, you might want to cache this mapping
        
        const componentMap = {
            1: 'NavBasic',
            2: 'Footer',
            3: 'Layout',
            4: 'DonationCard',
            5: 'Slider',
            6: 'MediaGallery',
            7: 'SimpleNewsTicker',
            8: 'SponsersGrid',
            9: 'FloatingButton',
            10: 'RichText',
            11: 'ColSection',
            12: 'HTML',
            1013: 'CardsSection',
            1014: 'Archive',
        };
        return componentMap[componentId] || 'Unknown';
    }

    async loadComponents() {
        try {
            const response = await PageService.GetComponentsByPageId(this.id);
            if (response.isSuccess) {
                this.components = response.result.map(pc => ({
                    id: pc.id,
                    name: this.getComponentNameById(pc.component.componentId),
                    data: pc.component.data ? JSON.parse(pc.component.data) : {},
                    order: pc.order,
                    ComponentId: pc.component.componentId
                }));
            }
        } catch (error) {
            console.error('Error loading page components:', error);
            throw error;
        }
    }

    async save() {
        try {
            const pageData = {
                title: this.title,
                isActive: this.isVisible,
                isTitleVisible: this.isTitleVisible,
                slug: this.link,
                description: `This is a description of the page ${this.title}`
            };

            if (this.id) {
                const response = await PageService.UpdatePage(this.id, pageData);
                if (response && response.isSuccess) {
                //     await this.saveComponents();
                    return response.isSuccess;
                }
            } else {
                const response = await PageService.CreatePageForAllLanguages(pageData);
                if (response && response.isSuccess) {
                    this.id = response.result.id;
                    return response.result;
                }
            }
            // throw new Error('Invalid response from server');
        } catch (error) {
            console.error('Error saving page:', error);
            throw error;
        }
    }

    async saveComponents() {
        try {
            if (!this.id) return;

            // First, get current components to compare
            const currentComponents = await ComponentService.GetComponentsByPageId(this.id);
            const currentComponentIds = currentComponents.data.map(c => c.id);

            // Update or add new components
            for (const component of this.components) {
                const componentData = {
                    pageId: this.id,
                    componentType: component.type,
                    componentData: component.data,
                    order: component.order
                };

                if (component.id) {
                    await ComponentService.UpdateComponent(component.id, componentData);
                } else {
                    await ComponentService.CreateComponent(componentData);
                }
            }

            // Remove components that are no longer in the list
            const newComponentIds = this.components.map(c => c.id).filter(id => id);
            const componentsToRemove = currentComponentIds.filter(id => !newComponentIds.includes(id));
            
            for (const componentId of componentsToRemove) {
                await ComponentService.DeleteComponent(componentId);
            }
        } catch (error) {
            console.error('Error saving page components:', error);
            throw error;
        }
    }

    async addComponent(component) {
        try {
            if (!component || !component.name || !component.ComponentId) {
                throw new Error('Invalid component data');
            }

            const newComponent = {
                id: null,
                name: component.name,
                data: JSON.stringify(component.data || {}),
                order: this.components.length + 1,
                language: component.language
            };

            const componentId = await this.newComponent(component);
            if (!componentId) {
                throw new Error('Failed to create component');
            }

            const assigned = await this.assignPageComponent(componentId, newComponent.order);
            if (!assigned) {
                await ComponentService.DeleteComponent(componentId);
                throw new Error('Failed to assign component to page');
            }
            newComponent.id = componentId;
            this.components.push(newComponent);
            return newComponent;

        } catch (error) {
            console.error('Error in addComponent:', error);
            throw error;
        }
    }

    async newComponent(component) {
        try {
            const componentData = {
                id: 0,
                ComponentId: component.ComponentId,
                data: JSON.stringify(component.data || {}),
                tenantId: "tenant-1",
                language: component.language
            };

            const response = await ComponentService.CreateComponent(componentData);
            console.log('CreateComponent Response:', response);
            
            if (!response || !response.id) {
                throw new Error('Component creation failed - no valid response');
            }

            return response.id;
        } catch (error) {
            console.error('Error in newComponent:', error);
            throw error;
        }
    }

    async assignPageComponent(id, order) {
        try {
            if (!this.id || !id) {
                throw new Error('Invalid page or component ID');
            }

            const pageComponentData = {
                pageId: this.id,
                componentId: id,
                order: order
            };
            const response = await pageComponentService.CreatePageComponent(pageComponentData);
            console.log('CreatePageComponent Response:', response);
            if (!response) {
                throw new Error('Failed to assign component to page - no response');
            }
            return true;
        } catch (error) {
            console.error('Error in assignPageComponent:', error);
            throw error;
        }
    }

    updateComponent(componentId, updatedData) {
        const index = this.components.findIndex(c => c.id === componentId);
        if (index !== -1) {
            this.components[index] = {
                ...this.components[index],
                ...updatedData
            };
        }
    }

    async removeComponent(componentId) {
        try {
            await pageComponentService.DeletePageComponent(componentId);
            this.components = this.components.filter(c => c.id !== componentId);
            // Reorder remaining components
            this.components.forEach((component, index) => {
                component.order = index + 1;
            });
        } catch (error) {
            console.error('Error removing component:', error);
            throw error;
        }
    }


    reorderComponents(newOrder) {
        this.components = newOrder.map((componentId, index) => {
            const component = this.components.find(c => c.id === componentId);
            if (component) {
                return { ...component, order: index + 1 };
            }
            return null;
        }).filter(Boolean);
    }

    getComponents() {
        return [...this.components];
    }

    setComponents(components) {
        this.components = components;
    }

    getTitle() {
        return this.title;
    }

    setTitle(title) {
        this.title = title;
    }

    getLink() {
        return this.link;
    }

    setLink(link) {
        this.link = link;
    }

    isPageVisible() {
        return this.isVisible;
    }

    setVisibility(isVisible) {
        this.isVisible = isVisible;
    }

    isTitleVisibleFlag() {
        return this.isTitleVisible;
    }

    setTitleVisibility(isVisible) {
        this.isTitleVisible = isVisible;
    }

    getOrder() {
        return this.order;
    }

    setOrder(order) {
        this.order = order;
    }

    async delete() {
        try {
            if (this.id) {
                await PageService.DeletePage(this.link);
            }
        } catch (error) {
            console.error('Error deleting page:', error);
            throw error;
        }
    }

    async saveComponentOrder() {
        try {
            if (!this.id) return;

            const orderData = this.components.map((component, index) => ({
                id: component.id,
                order: index + 1
            }));

            const response = await pageComponentService.UpdatePageComponentOrder(orderData);
            if (!response || !response.isSuccess) {
                throw new Error('Failed to save component order');
            }
            return response;
        } catch (error) {
            console.error('Error saving component order:', error);
            throw error;
        }
    }
}

export const createPageInstance = () => {
    return new Page();
};